import React, { memo, useMemo } from "react";
import {ActivityIndicator, ButtonProps, StyleSheet, Text, TextStyle, TouchableOpacity} from "react-native";
import { ButtonType, Frame, IsMobile } from "../theme";
import { Style, styles } from "../theme/styles";
import { AppTheme, useTheme } from "../theme/colors";

interface Props extends ButtonProps {
  variant?: ButtonType;
  bgColor?: string; // Add a bgColor prop to accept the background color
  buttonTextStyles?: TextStyle;
  loading?: boolean;
}

const Button = memo<Props>(({ loading = false, variant, bgColor, buttonTextStyles, ...props }) => {
  const theme = useTheme();

  const styles = getStyles(theme);

  const buttonStyle = useMemo<Style>(
    () => ({
      backgroundColor:
        bgColor || // Use the bgColor prop if provided
        (variant === ButtonType.primary
          ? theme.ACCENT
          : variant === ButtonType.secondary
          ? theme.PRIMARY
          : theme.WHITE),
    }),
    [variant, bgColor]
  );

  const $title = useMemo<Style | undefined>(() => {
    if (variant === undefined || variant === ButtonType.outline)
      return {
        color: theme.TEXT,
        fontWeight: "500",
      };

    return {
      color: theme.WHITE,
      fontWeight: "500",
    };
  }, [variant]);

  return (
    <TouchableOpacity
      style={[
        buttonStyle,
        IsMobile ? styles.mobilebuttonStyle : styles.desktopbuttonStyle,
        props.disabled && styles.disabled,
      ]}
      {...props}
    >
      {loading ? (
        <ActivityIndicator size="small" color="#ffffff" />
      ) : <Text style={[$title, buttonTextStyles]}>{props.title}</Text>}

    </TouchableOpacity>
  );
});

export default Button;

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
    desktopbuttonStyle: {
      ...styles.center,
      width: Frame.width / 5,
      borderRadius: 20,
      paddingVertical: 12,
    },
    mobilebuttonStyle: {
      ...styles.center,
      width: Frame.width / 2.7,
      borderRadius: 20,
      paddingVertical: 12,
    },
    disabled: {
      backgroundColor: theme.LIGHT_GREY,
      opacity: 0.6,
    },
  });
